












import Vue from 'vue';
export default Vue.extend({
  data() {
    return {
      links: [
        {
          name: 'bugs',
          path: '/critters/bugs',
        },
        {
          name: 'fish',
          path: '/critters/fish',
        },
        {
          name: 'sea',
          path: '/critters/sea',
        },
        {
          name: 'art',
          path: '/art',
        },
        {
          name: 'search',
          path: '/search',
        },
        {
          name: 'me',
          path: '/me',
        },
      ],
    };
  },
});
